import { has } from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import {
  SET_SME_PAYMENT_LIST,
  SET_TO_ACCOUNT_AFTER_ADD_PAYEE,
  SET_SME_PAYMENT_LIST_AFTER_ADD_PAYEE,
  SET_SME_BACK_URL,
  RESET_SME_BACK_URL,
  SET_PAYMENT_AUTH_LIST,
  RESET_PAYMENT_AUTH_LIST,
  SET_MANDATE_TO_EDIT,
  SET_PAYMENT_AUTH_TO_EDIT_BY_ID,
  SET_PAYMENT_TO_EDIT_BY_ID,
} from '../actions/MoveMoneySMEActionCreator';
import StringConstants from '../constants/StringConstants';

let paymentList = [];
let isAuthorisationEdit = false;
let isAuthorisationEditById = false;
let paymentToEdit = undefined;

let isManagePaymentEdit = false;

let paymentDetails = undefined;
let selectedPaymentId = null;
let backUrl = StringConstants.WEB_HOMEPAGE;
let paymentType = 'FASTER_PAYMENTS';
let templateName = null;
class MoveMoneySMEStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getSMEPaymentList() {
    return paymentList;
  }
  isAuthorisationEdit() {
    return isAuthorisationEdit;
  }
  isAuthorisationEditById() {
    return isAuthorisationEditById;
  }
  isManagePaymentEdit() {
    return isManagePaymentEdit;
  }
  getPaymentDetails() {
    return paymentDetails;
  }
  getSelectedSMEPayment() {
    return selectedPaymentId;
  }
  getPaymentToEdit() {
    return paymentToEdit;
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  reset() {
    isAuthorisationEdit = false;
    isManagePaymentEdit = false;
    paymentList = [];
    selectedPaymentId = null;
    paymentDetails = undefined;
    paymentType = 'FASTER_PAYMENTS';
    templateName = null;
    isAuthorisationEditById = false;
    paymentToEdit = undefined;
  }
  getBackUrl() {
    return backUrl;
  }

  getPaymentType() {
    return paymentType;
  }
  getTemplateInfo() {
    return { templateName };
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case AppConstants.LOGOUT_USER:
        this.reset();
        break;
      case SET_TO_ACCOUNT_AFTER_ADD_PAYEE:
        // FIXME :: Remove Mutation from here
        const selectedPayment = paymentList.find(
          (payment) => payment.id === selectedPaymentId
        );
        if (has(selectedPayment, 'toAccount')) {
          selectedPayment.toAccount = actionData.toAccount;
        } else {
          selectedPayment.fromAccount = actionData.toAccount;
        }
        selectedPayment.reference = actionData.reference;
        this.emitChange();
        break;
      case SET_SME_PAYMENT_LIST_AFTER_ADD_PAYEE:
        paymentList = [actionData];
        this.emitChange();
        break;

      case SET_SME_PAYMENT_LIST:
        paymentDetails = actionData.paymentsWithDetails.paymentDetails;
        paymentType = actionData.paymentType;
        paymentList = actionData.paymentsWithDetails.payments;
        selectedPaymentId = actionData.paymentsWithDetails.selectedPaymentId;
        templateName = actionData.paymentsWithDetails.templateName;
        this.emitChange();
        break;
      case SET_PAYMENT_AUTH_LIST:
        isAuthorisationEdit = true;
        paymentType = actionData.paymentType;
        paymentList = actionData.paymentsWithDetails.payments;
        paymentDetails = actionData.paymentsWithDetails.paymentDetails;
        this.emitChange();
        break;
      case SET_PAYMENT_AUTH_TO_EDIT_BY_ID:
        isAuthorisationEditById = true;
        paymentType = actionData.paymentType;
        paymentToEdit = actionData.paymentToEdit;
        this.emitChange();
        break;
      case SET_PAYMENT_TO_EDIT_BY_ID:
        isAuthorisationEditById = false;
        isManagePaymentEdit = true;
        paymentType = actionData.paymentType;
        paymentToEdit = actionData.paymentToEdit;
        this.emitChange();
        break;
      case RESET_PAYMENT_AUTH_LIST:
        this.reset();
        this.emitChange();
        break;
      case SET_SME_BACK_URL:
        backUrl = actionData;
        this.emitChange();
        break;

      case RESET_SME_BACK_URL:
        backUrl = StringConstants.WEB_HOMEPAGE;
        this.emitChange();
        break;
      case SET_MANDATE_TO_EDIT:
        isManagePaymentEdit = true;
        paymentList = [actionData];
        paymentToEdit = actionData.id;
        this.emitChange();
        break;
      case AppConstants.NAVIGATE_TO_WEB_TASK:
        if (
          !isAuthorisationEdit &&
          !isManagePaymentEdit &&
          !isAuthorisationEditById
        ) {
          this.reset();
        }
        this.emitChange();
        break;
      default:
    }
  }
}
export default new MoveMoneySMEStore();
